<template>

	<v-select
		:id="fieldId"
		:name="fieldName"
		:options="obj2Options(options)"
		:getOptionLabel="option => option.label"
		:value="valObj"
		:clearable="data.allow_clear"
    :selectable="canSelect"
		:placeholder="data.placeholder"
		:filterable="!useAjax"
		@open="onOpen"
		@input="selected"
		@search="onSearch"
		@close="$emit('close')"
		:class="data.cssClass"
		:disabled="disabled"
		:multiple="data.multiple"
	>
			<span slot="spinner" v-show="showLoader" class="select-loader"><i class="fad fa-circle-notch fa-spin fa-2x"></i></span>

	<template v-slot:no-options="{ search, searching }">
		<span v-if="!showLoader" class="pr-2 pl-2">
			No results found for <em>{{ search }}</em>.
		</span>
		<em v-else style="opacity: 0.5;">Loading...</em>
	</template>
	</v-select>

</template>

<script>
import vSelect from 'vue-select'
import field from '@/mixins/field';
import _ from 'lodash';


export default {
	components: { vSelect },
	mixins: [field],
	data() {
		return {
			options: this.data.options,
			showLoader: false,
			valObj: null
		}
	},
	computed: {
		useAjax() {
			return this.data.ajax.length > 0
		}
	},
	watch: {
		value(val) {
			if (this.useAjax) {
				this.getAjaxLabel(val)
			} else {
				this.valObj = val ? { code: val, label: this.options[val] } : null
			}
		},
		'data.reset'() {
			if (this.useAjax) {
				this.options = {};
			}
			if (this.data.dValue) {
				this.valObj = this.data.dValue ;
				this.$emit('input', this.data.dValue )
			} else {
				this.valObj = null
				this.selected(null)
			}
			
		}
	},
	methods: {
    canSelect(option) {
      return option.can_select
    },
		onOpen() {
			if (this.useAjax) {
				this.showLoader = true;
				this.options = {};
				var ajaxParams = typeof this.data.ajaxParams !== 'undefined' ? this.data.ajaxParams : null;
				axios.post(this.data.ajax,ajaxParams)
				.then((res) => {
					this.options = res.data;
					if (this.valObj) {
						//multiselect
						if (this.valObj instanceof Array) {
							this.valObj.forEach( (item) => this.options[item.code] = item.label )
						} else {
							this.options[this.valObj.code] = this.valObj.label;
						}
					} 
					this.showLoader = false;
				})
			}
		},
		onSearch(search, loading) {
			if (search.length && this.useAjax) { // to escape function trigger after select
				this.options = {};
				this.showLoader =  true;
				this.search(loading, search, this);
			}
			
		},
		search: _.debounce((loading, search, vm) => {
			axios.post(vm.data.ajax, { search: search } )
			.then((res) => {
				vm.options = res.data;
				vm.showLoader = false;
			});
		}, 350),
		selected(val) {
			this.valObj = val
			if (this.data.multiple) {
				var resp = val.map((obj) => {
					return obj.code;
				})
				this.$emit('input',resp.join())
			} else {
				this.$emit('input', val ? val.code : null )
			}
			this.$emit('change', val)
		},
		getAjaxLabel(val) {
			if (val) {

				//if multiple selected on front end the value is returned as an array of objects. hash needs to be extratced
				//and turned into a comma separated string
				if (this.data.multiple && val instanceof Array) { 
					val = val.map((o) => o.code).join()
				}

				var dataRequest = { hash: val };

				this.showLoader = true;
				axios.post(this.data.ajax, dataRequest)
				.then((res) => {
					// Rollbar #83 / #124: server may return null or an
					// empty payload when the row no longer exists. Guard
					// against null res.data before reading keys/values.
					const data = res.data && typeof res.data === 'object' ? res.data : {};
					this.options = data;
					if (this.data.multiple) {
						this.valObj = [];
						Object.keys(data).forEach(key => {
              				this.valObj.push({ code: key, label: data[key] })
						});
					} else {
						this.valObj = { code: val, label: data[val] }
					}
					this.showLoader = false;
				})
			
			}
		},
		onmount() {
			if (this.value) {
				if (this.useAjax) {
					this.getAjaxLabel(this.value)
				} else {
					this.valObj = { code: this.value, label: this.options[this.value] }
				}
			}
		}
	},
	mounted() {
		this.onmount()
	}
	
}
</script>